import axios from 'axios';

const axiosAuthConfig = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000, // Set a timeout for requests
    validateStatus: function (status) {
        // Accept only 2xx status codes
        return status >= 200 && status < 300;
    }
    
});

const pendingRequests = new Map();

// Request Interceptor
axiosAuthConfig.interceptors.request.use(
    config => {
        // Cancel duplicate requests
        const requestIdentifier = `${config.url}_${config.method}`;
        if (pendingRequests.has(requestIdentifier)) {
            const cancelTokenSource = pendingRequests.get(requestIdentifier);
            cancelTokenSource.cancel('Cancelled due to new request');
        }
        const newCancelTokenSource = axios.CancelToken.source();
        config.cancelToken = newCancelTokenSource.token;
        pendingRequests.set(requestIdentifier, newCancelTokenSource);

        // Add Authorization header
        const accessToken = sessionStorage.getItem('user');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

// Response Interceptor
axiosAuthConfig.interceptors.response.use(
    response => {
        // Remove completed requests from the map
        const requestIdentifier = `${response.config.url}_${response.config.method}`;
        pendingRequests.delete(requestIdentifier);
        return response;
    },
    error => {
        if (error.config) {
            const requestIdentifier = `${error.config.url}_${error.config.method}`;
            pendingRequests.delete(requestIdentifier);
        }

        if (error.response) {
            const { status, data } = error.response;

            if (status === 401) {
                // Handle token expiration or unauthorized access
                console.log('Token expired or unauthorized:', data);
                // Optionally, redirect to login page or refresh token
            } else {
                console.log('Response error:', data);
            }
        } else if (error.request) {
            console.log('Request error:', error.request);
        } else {
            console.log('Error:', error.message);
        }

        return Promise.reject(error);
    }
);

export default axiosAuthConfig;